import React from 'react';
import { AboutReviews, BasicInfoBar, Faq, GreetingsInfo, HistoryCard, HowItWorks, RoutesCards } from '@widgets';

// Мета-теги, canonical, hreflang и JSON-LD главной формируются при пререндере (src/app/lib/seo.ts).
const MainPage: React.FC = () => {
  return (
    <main style={{ overflow: 'hidden' }}>
      <GreetingsInfo />
      <BasicInfoBar />
      <section id="routes">
        <RoutesCards />
      </section>
      <HistoryCard />
      <section id="how">
        <HowItWorks />
      </section>
      <section id="faq">
        <Faq />
      </section>
      <section id="about">
        <AboutReviews />
      </section>
    </main>
  );
};

export default MainPage;
